import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IOpportunityType } from "../opportunityTypeModel";

export const getAllOpportunityType = createAsyncThunk(
  "OpportunityType/OpportunityTypeFindAll",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeFindAll`,
        {
          OpportunityType: "",
        }
      );
      //   return response.data?.Data;
      if (response?.data?.Status === 200) {
        // SuccessToast(response.data?.Details || "Success");
        return response.data?.Data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching Opportunity Types:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createOpportunityType = createAsyncThunk(
  "OpportunityType/OpportunityTypeInsert",
  async (OpportunityType: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeInsert`,
        OpportunityType
      );
      if (response.data?.Status === 201) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Inserting Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateOpportunityType = createAsyncThunk(
  "OpportunityType/OpportunityTypeUpdate",
  async (OpportunityType: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeUpdate`,
        OpportunityType
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Updating Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getOpportunityTypeById = createAsyncThunk(
  "OpportunityType/OpportunityTypeFindByID",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeFindByID`,
        {
          OpportunityTypeGUID: ID,
        }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        OpportunityTypeGUID: result.OpportunityTypeGUID,
        OpportunityType: result.OpportunityType,
        IsActive: result.IsActive === true ? 1 : 2,
      } as IOpportunityType;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteOpportunityType = createAsyncThunk(
  "OpportunityType/OpportunityTypeDelete",
  async (ID: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeDelete`,
        {
          OpportunityTypeGUID: ID,
        }
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const findAllActiveOpportunityType = createAsyncThunk(
  "OpportunityType/OpportunityTypeFindAllActive",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/OpportunityType/OpportunityTypeFindAllActive`
      );
      // SuccessToast(response.data?.Details || "Success")
      return response.data.Data;
    } catch (error: any) {
      console.error("Error Deleting Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const OpportunityTypeActiveInactive = createAsyncThunk(
  "OpportunityType/OpportunityTypeActiveInActive",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/OpportunityType/OpportunityTypeActiveInActive`,
        formData
      );
      if (response.data?.Status === 200) {
        SuccessToast(response.data?.Details || "Success");
        return response.data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Opportunity Type:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
